import type { SourceDocument } from "../lib/documentSearch/types";
import { NoResultsState } from "./NoResultsState";
import { SourceCard } from "./SourceCard";

type SourceResultsProps = {
  results: SourceDocument[];
  selectedId: string | null;
  pinnedIds: string[];
  chatSelectedIds: string[];
  chatSelectionFull: boolean;
  onSelect: (document: SourceDocument) => void;
  onPinToggle: (document: SourceDocument) => void;
  onChatToggle: (document: SourceDocument) => void;
  onChatStart: () => void;
};

export function SourceResults({
  results,
  selectedId,
  pinnedIds,
  chatSelectedIds,
  chatSelectionFull,
  onSelect,
  onPinToggle,
  onChatToggle,
  onChatStart,
}: SourceResultsProps) {
  if (results.length === 0) {
    return <NoResultsState />;
  }

  const className = [
    "source-results",
    results.length <= 2 ? "source-results--short" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={className} aria-label="Source results">
      <div className="source-results__header">
        <span>Sources ({results.length})</span>
        <button
          className="primary-button source-results__chat-button"
          type="button"
          disabled={chatSelectedIds.length === 0}
          onClick={onChatStart}
        >
          Chat with selected ({chatSelectedIds.length})
        </button>
      </div>
      {results.map((document, index) => (
        <SourceCard
          key={document.id}
          document={document}
          rank={index + 1}
          selected={selectedId === document.id}
          pinned={pinnedIds.includes(sourceIdFor(document))}
          chatSelected={chatSelectedIds.includes(sourceIdFor(document))}
          chatSelectionFull={chatSelectionFull}
          onSelect={() => onSelect(document)}
          onPinToggle={() => onPinToggle(document)}
          onChatToggle={() => onChatToggle(document)}
        />
      ))}
    </section>
  );
}

function sourceIdFor(document: SourceDocument): string {
  return document.sourceDocumentId ?? document.id;
}
